export const GET_ALL_RATINGS = "get/all/ratings";
export const ADD_RATINGS = "add/ratings";
export const UPDATE_RATINGS = "update/ratings";
export const DELETE_RATINGS = "delete/ratings";
export const LOADING_RATINGS = "loading/ratings";
export const ERROR_RATINGS = "error/ratings";
export const RESET_RATINGS = "reset/ratings";
